import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import {colors, fonts, margins, settings} from "../theme/config.json";
import {InlineText} from "../theme";


export const ButtonContainer = styled.span`
  display:table;
  width: ${props => props.inline ? 'auto !important' : '100% !important'};
`;
 
export const ButtonSmall = styled.div`
  border: ${settings.borderline}px solid ${colors.textPrimary};
  border-top: ${props=>props.noTop?'0px':null};
  border-bottom: ${props=>props.noBottom?'0px':null};
  width: ${settings.containerpadding}px !important;
  display:table-cell;
  padding: ${settings.containerpadding}px;
  border-left: ${props=>props.noLeft?'0px':null};
  border-right: ${props=>props.noRight?'0px':null};
  background-color: ${colors.primary};
`;

export const ButtonCenter = styled.div`
  padding: ${settings.containerpadding}px;
  border-top: ${props=>props.noTop?'0px':settings.borderline+"px solid "+colors.textPrimary};
  border-bottom: ${props=>props.noBottom?'0px':settings.borderline+"px solid "+colors.textPrimary};
  padding-top: ${settings.containerpadding*1.3}px;
  padding-bottom: ${settings.containerpadding*1.3}px;
  margin-left: ${margins.text.left};
  margin-top: ${margins.text.top};
  text-align: center;
  display:table-cell;
  text-transform: ${fonts.transform.title};
  background-color: ${colors.primary};
  color: ${colors.textPrimary};
  &:hover {
    background-color: ${colors.secondary};
    color: ${colors.textSecondary};
    cursor: crosshair;
  }
`;

const Button = ({ inline, link, text, onClick, options, component }) => {
    options = options || {};
    let hideTop = options.noTop;
    let hideBottom = options.noBottom;
    let hideSides = options.noSides;

    let renderInner = (
        <ButtonCenter noTop={hideTop} noBottom={hideBottom}>
            {component?component():<span style={{fontSize: fonts.size.book, fontWeight: options.bold?"bold":"normal"}} dangerouslySetInnerHTML={{ __html: text}} />}
        </ButtonCenter>
    )

    let sml = <ButtonSmall noTop={hideTop} noBottom={hideBottom} noLeft={hideSides}/>
    let smr = <ButtonSmall noTop={hideTop} noBottom={hideBottom} noRight={hideSides}/>
    

    if (link) {
        if (options.external){
            return (
                <a href={link} target="_blank" rel="noopener noreferrer" style={{textDecoration: "none"}} >
                    <ButtonContainer inline = {inline? true : false}>
                    {sml}{renderInner}{smr}
                    </ButtonContainer>
                </a>
            )
        } else {
            return (
                <Link to={link} style={{textDecoration: "none"}}>
                    <ButtonContainer inline = {inline? true : false}>
                    {sml}{renderInner}{smr}
                    </ButtonContainer>
                </Link>
            )
        }
    } else if (onClick) {
        return (
            <ButtonContainer inline = {inline? true : false} onClick={onClick}>
                {sml}{renderInner}{smr}
            </ButtonContainer>
        )
    } else {
        return (
            <h1>this is probs not a button</h1>
        )
    }
}

export default Button